import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

export const renderFileInfoModal = ({ id, storage, isArchiveInfo }: { id: string; storage: EStorageType; isArchiveInfo?: boolean }) =>
    openPopupHelper({ popupName: popupNames.MOBILE_FILE_INFO_MODAL, data: { id, storage, isArchiveInfo } });
